import {GotchaTypeVo} from '../../common/shared/api/nicolas/vo/enums/GotchaTypeVo.enum';
import {GotchaType} from '../generated/types';

export function createGotchaType(gotchaTypeVo: GotchaTypeVo): GotchaType {
  return mapper[gotchaTypeVo];
}

const mapper: {[key in GotchaTypeVo]: GotchaType} = {
  [GotchaTypeVo.Standalone]: GotchaType.Standalone,
  [GotchaTypeVo.CashSponsor]: GotchaType.CashSponsor,
};
